module.exports = __webpack_public_path__ + "img/01.5c7e053a.jpg";